import { all, put, take, race, select, takeEvery } from 'redux-saga/effects'
import { SUCCESS, FAILED } from 'crom-api-constants'
import _ from 'lodash'

import { getToken, getLocale, getCustomData } from '@global/selectors'

import {
    ANNOTATIONS_TABLE_CHANGE,
    ANNOTATIONS_TABLE_LOADING_TRUE,
    ANNOTATIONS_TABLE_CHANGE_REQUEST,
    ANNOTATIONS_TABLE_DATA_RECEIVED,
    ANNOTATIONS_TABLE_LOADING_FALSE,
} from './constants'

import {
    annotationsTableLoadingTrue,
    annotationsTableChangeRequest,
    annotationsTableDataReceived,
    annotationsTableLoadingFalse,
} from './actions'

import { BLOCK_DATA_LOADED } from '../../../../../../../components/Workspace/components/HocBlock/constants'
import { blockSaveCustomData } from '../../../../../../../components/Workspace/components/HocBlock/actions'
import config from '../../../../../../../../../config'

const ANNOTATIONS_TABLE_CHANGE_REQUEST_SUCCESS = (id) => `${ANNOTATIONS_TABLE_CHANGE_REQUEST(id)}_${SUCCESS}`
const ANNOTATIONS_TABLE_CHANGE_REQUEST_FAILED = (id) => `${ANNOTATIONS_TABLE_CHANGE_REQUEST(id)}_${FAILED}`

function* onDataLoaded(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.anotace.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const tableData = _.get(action, 'data.data[1].annotations', [])
    const pagination = _.get(action, 'data.data[1].query.pagination')
    const sorted = _.reduce(
        _.get(action, 'data.data[1].query.sort.sortedColumns', []),
        (acc, val) => [
            ...acc,
            {
                id: _.get(val, 'columm'), // TYPO FROM BACKEND
                desc: _.get(val, 'direction') === 'desc',
            },
        ],
        []
    )

    yield put(
        blockSaveCustomData(module, id, blockKey, {
            table: {
                rows: tableData,
                pagination,
                sorted,
                isLoading: false,
            },
        })
    )

    return null
}

function* tableChangeSaga(action) {
    const module = _.get(action, 'data.module', null)
    const blockKey = _.get(action, 'data.blockKey', null)
    const id = _.get(action, 'data.id', null)
    const level = _.get(action, 'data.level', null)
    const customData = _.get(action, 'data.customData', null)
    const queryParams = _.get(action, 'data.queryParams', null)

    const locale = yield select(getLocale)
    const token = yield select(getToken, id, module)

    const lang = config.languages[locale].requestKey

    if (!module || !blockKey || !id || !level) return null

    yield put(
        annotationsTableLoadingTrue(module, id, blockKey, {
            table: {
                ..._.get(customData, 'table', {}),
                isLoading: true,
            },
        })
    )

    const qp = {
        // filters: [],
        'sort[]': _.map(_.get(queryParams, 'sorted', []), (val) => `${_.get(val, 'id')}${val.desc ? ':desc' : ':asc'}`),
        page: _.get(queryParams, 'pagination.page'),
        rows: _.get(queryParams, 'pagination.rowsPerPage'),
    }

    yield put(annotationsTableChangeRequest(module, blockKey, id, level, lang, token, qp))

    const response = yield race({
        success: take(ANNOTATIONS_TABLE_CHANGE_REQUEST_SUCCESS(id)),
        failed: take(ANNOTATIONS_TABLE_CHANGE_REQUEST_FAILED(id)),
    })

    if (!response.failed) {
        const rows = _.map(_.get(response, 'success.payload.response.body.annotations'), (row) => ({ ...row }))
        const query = _.get(response, 'success.payload.response.body.query', [])
        const pagination = _.get(query, 'pagination', null)
        const sorted = _.reduce(
            _.get(query, 'sort.sortedColumns'),
            (acc, val) => [
                ...acc,
                {
                    id: _.get(val, 'columm'), // TYPO FROM BACKEND
                    desc: _.get(val, 'direction') === 'desc',
                },
            ],
            []
        )

        const newCustomData = {
            table: {
                rows,
                pagination,
                sorted,
                isLoading: false,
            },
        }

        yield put(annotationsTableDataReceived(module, id, blockKey, newCustomData))
    } else {
        yield put(
            annotationsTableLoadingFalse(module, id, blockKey, {
                table: {
                    ..._.get(customData, 'table', {}),
                    isLoading: false,
                },
            })
        )
    }
    return null
}

function* annotationsChangeCustomData(action) {
    const blockKey = _.get(action, 'data.blockKey', null)
    if (blockKey !== config.modules.report.blocks.anotace.key) return null

    const module = _.get(action, 'data.module', null)
    const id = _.get(action, 'data.id', null)
    if (!module || !id || !blockKey) return null

    const incomingChange = _.get(action, 'data.customData', {})
    const customData = yield select(getCustomData, module, blockKey, id)

    yield put(blockSaveCustomData(module, id, blockKey, { ...customData, ...incomingChange }))

    return null
}

export default function* annotationsSaga() {
    yield all([
        takeEvery(BLOCK_DATA_LOADED, onDataLoaded),
        takeEvery(ANNOTATIONS_TABLE_CHANGE, tableChangeSaga),
        takeEvery(ANNOTATIONS_TABLE_LOADING_TRUE, annotationsChangeCustomData),
        takeEvery(ANNOTATIONS_TABLE_LOADING_FALSE, annotationsChangeCustomData),
        takeEvery(ANNOTATIONS_TABLE_DATA_RECEIVED, annotationsChangeCustomData),
    ])
}
